import { render, staticRenderFns } from "./CorporationsTable.vue?vue&type=template&id=f5709658&"
import script from "./CorporationsTable.vue?vue&type=script&lang=js&"
export * from "./CorporationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports